import { atom } from 'recoil';
import { AiMessage } from '../../components/AiAnalysis';

export const aiMessagesState = atom<AiMessage[]>({
  key: 'aiMessagesState',
  default: [],
  effects: [],
});

export const aiLoadingState = atom<boolean>({
  key: 'aiLoadingState',
  default: false,
  effects: [],
});

export const aiActiveState = atom<boolean>({
  key: 'aiActiveState',
  default: false,
  effects: [],
});
